module.exports = __webpack_public_path__ + "img/map-2-f@2x.c0b2c4bb.png";